import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import type { OperatorForm } from 'modules/reports/components/Editor/Field/Options/Types/Filtering/forms'
import { OPERATORS } from 'modules/reports/lib/Constants'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

interface Props {
  forms: ArgumentForm[]
  operatorForm: OperatorForm
}

const LeaveTypeSelector = ({ forms, operatorForm }: Props) => {
  const [loading, setLoading] = React.useState<boolean>(true)
  React.useEffect(() => {
    const fetchData = async () => await leaveTypes.fetch()

    fetchData()
    setLoading(false)
  }, [])

  const options = (): SelectOption[] => {
    return leaveTypes.models.map((item) => {
      if (item.isCustom) {
        return {
          value: item.attributes.translated_name,
          label: item.attributes.translated_name,
        }
      }

      return {
        value: item.attributes.translated_name,
        label: item.attributes.translated_name,
      }
    })
  }

  const form = forms[0]

  if (
    operatorForm.get('value').value === OPERATORS.starts_with ||
    operatorForm.get('value').value === OPERATORS.contains
  ) {
    return form ? (
      <FormRow>
        <Text
          label={i18n.t('custom_reports.filter_arguments_labels.value')}
          field={form.get('value')}
        />
      </FormRow>
    ) : null
  }

  if (loading) return <Loading />

  return form ? (
    <FormRow>
      <Select
        none={i18n.t('custom_reports.especial_filters.leave_type.none')}
        label={i18n.t('custom_reports.especial_filters.leave_type.label')}
        field={form.get('value')}
        options={options()}
      />
    </FormRow>
  ) : null
}

export default observer(LeaveTypeSelector)
